// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"e0cebb94","369":"d56109ae"}[chunkId] + ".chunk.js";
};